import React from 'react';
import { ErrorMessage } from '@hookform/error-message';
import FormElemErrorLabel from '../FormElemErrorLabel';

export default function ErrorLabel({ errors, name = '' }) {
  return (
    <ErrorMessage
      errors={errors}
      name={name}
      render={({ message }) => <FormElemErrorLabel label={message} show inputName={name} />}
    />
  );
}
